var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3W(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3dad1675b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92 67 L 329 67 L 329 347.839844 L 92 347.839844 Z M 92 67 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3dad1675b8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 319.800781 125.734375 C 313.742188 109.03125 304.90625 94.210938 294.011719 81.585938 L 307.867188 67.984375 L 148.15625 115.25 L 253.132812 157.335938 C 262.589844 161.125 270.457031 168.042969 275.433594 176.929688 C 286.816406 197.261719 280.613281 222.933594 261.199219 235.828125 L 92.035156 348.15625 L 176.234375 314.027344 C 198.34375 315.792969 221.222656 312.359375 243.097656 302.945312 C 311.167969 273.640625 345.058594 195.40625 319.800781 125.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 91.132812 131.042969 C 85.523438 107.460938 100.136719 83.808594 123.730469 78.273438 L 251.539062 48.273438 C 214.820312 29.484375 170.117188 26.832031 129.191406 45.335938 C 62.570312 75.457031 29.976562 152.746094 54.894531 221.488281 C 60.558594 237.101562 68.65625 251.070312 78.59375 263.144531 L 204.660156 195.707031 L 117.769531 161.6875 C 104.402344 156.453125 94.457031 145.003906 91.132812 131.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3W);
export default __webpack_public_path__ + "static/media/3W.672b32c58e3d029aec4c04548953af8b.svg";
export { ForwardRef as ReactComponent };